import React, { useState } from 'react'
import DrugsAndPrescription from '../accordions/DrugsAndPrescription'
import { Form } from "react-bootstrap";

const MedicationTable = ({handleFetchDrugs, drugs, loading}) => {
    const [searchQuery, setSearchQuery] = useState("")

    const filteredData = drugs?.result?.filter( (item) =>
      item?.patient?.hmo?.name?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      item?.requestType?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      item?.item?.vaccine?.name_of_vaccine?.toLowerCase()?.includes(searchQuery?.toLowerCase())        
  );
   
// console.log("result",filteredData)

  return (
    <>
        <div className="data-panel-head">
            <div className="data-panel-copy">
              <h5>Medication history</h5>
              <p>Search prescriptions, then expand each record for the medication details underneath.</p>
            </div>
            <div className="data-panel-actions">
              <div className="data-search">
                <Form.Control
                    type="text"
                    placeholder="Search plan, request type, or vaccine"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
              </div>
            </div>
        </div>

        <div className="data-table-shell">
          <DrugsAndPrescription loading={loading} searchQuery={searchQuery} filteredData={filteredData}/>
        </div>
    </>
  )
}

export default MedicationTable
